// src/app/trainingSlice.ts
import { PayloadAction } from "@reduxjs/toolkit";
import { createAppSlice } from "../app/createAppSlice";

export interface ITrainingState {
  activeTdRoomId: string | null;
}

const initialState: ITrainingState = {
  activeTdRoomId: null,
};

export const trainingSlice = createAppSlice({
  name: "training",
  initialState,
  reducers: {
    setActiveTdRoomIdInRedux(state, action: PayloadAction<ITrainingState["activeTdRoomId"]>) {
      state.activeTdRoomId = action.payload;
    },
    clearActiveTdRoomId(state) {
      state.activeTdRoomId = null;
    },
  },
});

export const { setActiveTdRoomIdInRedux, clearActiveTdRoomId } = trainingSlice.actions;

export default trainingSlice.reducer;
